import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { IntegrationFormState } from "../../types";

interface CredentialSelectorProps {
  formData: IntegrationFormState;
  setFormData: (data: IntegrationFormState) => void;
}

const CredentialSelector = ({ formData, setFormData }: CredentialSelectorProps) => {
  return (
    <>
      <div>
        <Label className="text-sm font-semibold">Credential Type *</Label>
        <select
          value={formData.credential_type || "api_key_header"}
          onChange={(e) =>
            setFormData({
              ...formData,
              credential_type: e.target.value as any,
            })
          }
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm mt-2"
        >
          <option value="api_key_header">API Key (Header)</option>
          <option value="bearer_token">Bearer Token</option>
          <option value="basic_auth">Basic Auth</option>
          <option value="oauth2">OAuth 2.0</option>
        </select>
      </div>

      {formData.credential_type === "api_key_header" && (
        <>
          <div>
            <Label className="text-sm font-semibold">Header Name *</Label>
            <Input
              type="text"
              placeholder="e.g., X-API-Key, Authorization"
              value={formData.auth_header_name || ""}
              onChange={(e) =>
                setFormData({ ...formData, auth_header_name: e.target.value })
              }
              className="mt-2"
              autoComplete="chrome-off"
              name="api_header_name"
            />
          </div>
          <div>
            <Label className="text-sm font-semibold">API Key *</Label>
            <Input
              type="password"
              placeholder="Your API key"
              value={formData.api_key || ""}
              onChange={(e) =>
                setFormData({ ...formData, api_key: e.target.value })
              }
              className="mt-2"
              autoComplete="new-password"
              name="api_key_value"
            />
          </div>
        </>
      )}

      {formData.credential_type === "bearer_token" && (
        <div>
          <Label className="text-sm font-semibold">Bearer Token *</Label>
          <Input
            type="password"
            placeholder="Your bearer token"
            value={formData.token || ""}
            onChange={(e) =>
              setFormData({ ...formData, token: e.target.value })
            }
            className="mt-2"
            autoComplete="off"
          />
        </div>
      )}

      {formData.credential_type === "basic_auth" && (
        <>
          <div>
            <Label className="text-sm font-semibold">Username *</Label>
            <Input
              type="text"
              placeholder="Username"
              value={formData.username || ""}
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
              className="mt-2"
              autoComplete="chrome-off"
              name="integration_username"
            />
          </div>
          <div>
            <Label className="text-sm font-semibold">Password *</Label>
            <Input
              type="password"
              placeholder="Password"
              value={formData.password || ""}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              className="mt-2"
              autoComplete="new-password"
              name="integration_password"
            />
          </div>
        </>
      )}

      {formData.credential_type === "oauth2" && (
        <div>
          <Label className="text-sm font-semibold">Access Token *</Label>
          <Input
            type="password"
            placeholder="Your OAuth 2.0 access token"
            value={formData.token || ""}
            onChange={(e) =>
              setFormData({ ...formData, token: e.target.value })
            }
            className="mt-2"
            autoComplete="off"
          />
        </div>
      )}
    </>
  );
};

export default CredentialSelector;
